/**
 * Available Mobiz error types.
 * NOTE: This matches the enum available on the backend.
 * @see: Mobiz.Controllers.Api.ManagementController.MobizErrorType
 */
export type MobizErrorType =
  /**
   * Handles error tracking and response for ArgumentException or derived types in Mobiz.
   * Everywhere in mobiz when we encounter INVALID USER INPUT we throw ArgumentException or derived.
   */
  'InvalidArgument' |
  /**
   * Validation error in the context of ERP actions.
   *
   * NOTE: The ERP Validation errors should be displayed as info messages, not error messages.
   */
  'Validation' |
  /**
   * Handles error tracking and response for ForbiddenException in Mobiz.
   */
  'Forbidden' |
  /**
   * Handles internal server errors from Mobiz.
   */
  'InternalServerError' |
  /**
   * Handles OAuth errors responses in Mobiz.
   */
  'OAuth' |
  /**
   * Handles uncategorized error responses.
   */
  'Uncategorized';
